import { ElementType } from 'react';

import { DisplayRefDisplayType } from '@repo/sdk/models/components';

import { SettingFieldBoolean } from '@/features/equipment-browser/equipment-details/settings/components/setting-field-boolean';
import { SettingFieldButton } from '@/features/equipment-browser/equipment-details/settings/components/setting-field-button';
import { SettingFieldDropdown } from '@/features/equipment-browser/equipment-details/settings/components/setting-field-dropdown';
import { SettingFieldInput } from '@/features/equipment-browser/equipment-details/settings/components/setting-field-input';
import { SettingFieldLabel } from '@/features/equipment-browser/equipment-details/settings/components/setting-field-label';

export const settingsInputMap: Record<DisplayRefDisplayType, ElementType> = {
  [DisplayRefDisplayType.Label]: SettingFieldLabel,
  [DisplayRefDisplayType.Button]: SettingFieldButton,
  [DisplayRefDisplayType.Dropdown]: SettingFieldDropdown,
  [DisplayRefDisplayType.Input]: SettingFieldInput,
  [DisplayRefDisplayType.Switch]: SettingFieldBoolean,
};
